
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 50 50"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M45.7 45.8H4.1l.2-1.5c0-.2.9-5.5 5.3-7.9 3-1.7 7.1-3.8 8.7-4.6 0-1 .1-2.6.1-3.5-.7-1.1-1.8-3.3-2-4.6-.1-.3-.3-.7-.6-1.2-.5-.8-1.2-1.8-1.2-3.2 0-1 .2-1.9.3-2.4-.1-.5-.2-1.8-.2-2.7v-1c-.1-1.2-.1-2.5.2-3.6.5-1.6 3.4-4.7 5.2-5.6 0 0 .1 0 .1-.1.6-.3 2.2-1.2 4.7-1.4.7 0 1.2.1 1.2.1h.2s1.3.5 3.3 1.1c2.2.7 5 4.4 5.4 5.8.3 1 .3 2.4.2 3.6v1c0 .9-.1 2.2-.2 2.7.1.4.3 1.3.3 2.4 0 1.4-.7 2.4-1.2 3.2-.3.4-.6.8-.6 1.2-.2 1.3-1.3 3.6-2 4.6 0 .8.1 2.5.1 3.5 1.6.8 5.6 2.9 8.7 4.6 4.3 2.4 5.2 7.7 5.3 7.9l.1 1.6zM7.2 43.3h35.4c-.5-1.4-1.6-3.5-3.6-4.7-3.8-2.1-9.2-4.8-9.2-4.8l-.7-.3v-.7c0-.2-.1-3.9-.1-4.7v-.5l.4-.4c.3-.4 1.5-2.7 1.7-3.7.1-.8.6-1.5 1-2.1.4-.6.8-1.2.8-1.8 0-1-.3-1.9-.3-1.9l-.1-.3v-.3s.2-1.6.2-2.7v-1.1c0-.9.1-2.1-.1-2.7-.2-.8-2.6-3.7-3.8-4.2-1.7-.6-2.8-1-3.2-1.1h-.7c-2 .2-3.2.8-3.7 1.1-.1 0-.1.1-.2.1-1.4.7-3.7 3.4-3.9 4.1-.2.6-.1 1.8-.1 2.7v1.1c0 1 .2 2.6.2 2.7v.3l-.1.3s-.3.9-.3 1.9c0 .7.4 1.2.8 1.8.4.6.9 1.3 1 2.1.2 1.1 1.3 3.3 1.7 3.7l.4.4v.4c0 .8-.1 4.5-.1 4.7v.7l-.6.3c-.1 0-5.5 2.7-9.2 4.8-2.1 1.2-3.1 3.4-3.6 4.8z"}})])
          )
        }
      }
    